import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/imgcaptions/aiLogo.png'


const _hoisted_1 = { class: "itemBox" }
const _hoisted_2 = { class: "itemBoxImg" }
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 1,
  src: _imports_0,
  alt: ""
}
const _hoisted_5 = { class: "close" }
const _hoisted_6 = {
  key: 0,
  class: "chatItemBoxmask"
}
const _hoisted_7 = { class: "chatitemdelBox" }

import { computed,ref,getCurrentInstance} from "vue";
  // 引入删除提示
import delbox from "@/components/common/del.vue";
  
export default /*@__PURE__*/_defineComponent({
  __name: 'ChatgtpItem',
  props: {
    id: {
      type: String,
      required: true,
      default: "",
    },
    avatar: {
      type: String,
      required: true,
      default: "https://t11.baidu.com/it/u=2468644573,209288196&fm=30&app=106&f=JPEG",
    },
    intro: {
      type: String,
      required: false,
      default: '',
    },
    model: {
      type: String,
      required: true,
      default: "",
    },
    name: {
      type: String,
      required: true,
      default: "",
    },
    active: {
      type: Boolean,
      required: false,
      default: false,
    },
   
  },
  emits: ["del"],
  setup(__props, { emit: __emit }) {

//   import Avatar from "@/components/Avatar.vue";
  let { proxy } = getCurrentInstance()
  const props = __props;
  // 刪除该对话
  const opendelShow=ref(false)
  const delTextword=ref('是否刪除该对话，删除将无法恢复！')
  const delId=ref('')
  const opendelBox=(id:string)=>{
    console.log('刪除该对话')
    delId.value=id
    opendelShow.value=true
  }
  const emit = __emit;
  const recognition = () => {
    opendelShow.value=false
    emit('del',delId.value)
  };
  
  // console.log(typeof(props.text))
  // console.log(props.text)
  // if(props.text.indexOf('param')>0){
  //   console.log(JSON.parse(props.text))
  // }
  
//   let emit = defineEmits(["del"]);
  
    
  
//   const confirmEvent = () => {
//     emit("del", props.id);
//   };
  
return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["item", __props.active ? 'active' : ''])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (__props.avatar!=undefined&& __props.avatar.indexOf('http')<0)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: _unref(proxy).getimgUrl+__props.avatar,
              alt: ""
            }, null, 8, _hoisted_3))
          : _createCommentVNode("", true),
        (__props.avatar!=undefined&& __props.avatar.indexOf('http')>=0)
          ? (_openBlock(), _createElementBlock("img", _hoisted_4))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("div", {
          style: _normalizeStyle(__props.active ? {'color':'#fff' }: '')
        }, _toDisplayString(__props.name), 5),
        _createElementVNode("div", {
          style: _normalizeStyle(__props.active ? {'color':'#aaa' }: '')
        }, _toDisplayString(__props.model), 5)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("i", {
          class: "iconfont icon-v-guanbi1",
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (opendelBox(__props.id)), ["stop"]))
        })
      ])
    ]),
    _createElementVNode("div", null, [
      (opendelShow.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(delbox, {
                text: delTextword.value,
                onCloseThis: _cache[1] || (_cache[1] = ($event: any) => (opendelShow.value = false)),
                onRecognition: recognition
              }, null, 8, ["text"])
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ], 2))
}
}

})